export const getAboutUs = '/about-us';
export const addAboutUs = '/about-us';
export const updateAboutUs = '/about-us/';
